import Create from "./Create";
import CreateUpdate from "./CreateUpdate";
import Login from "./Login";
import Logout from "./Logout";
import Oauth from "./oauth";
import Overlay from "./Overlay";
import PasswordForgot from "./PasswordForgot";
import Update from "./Update";
import UpdateForm from "./UpdateForm";
import Interface from "./Interface";

export default {
  Create,
  CreateUpdate,
  Login,
  Logout,
  Oauth,
  Overlay,
  PasswordForgot,
  Update,
  UpdateForm,
  Interface
};
